import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { Router } from '@angular/router';

export class ErrorHandlerService implements ErrorHandler {

  public static storage = 'patent_search_last_error';

  public static errorLocation = 'patent_search_last_error_location';

  constructor(private injector: Injector, private zone: NgZone) {
    // Make sure errors are cleaned up on initialization
    this.clearErrors();
  }

  public handleError(error: any): void {
    // Clear the previous errors
    this.clearErrors();

    // Set the router;
    const router = this.injector.get(Router);

    // Make sure the error is logged.
    console.error(error);

    // Save the last error for rendering on the error page.
    window.localStorage.setItem(ErrorHandlerService.storage, error.toString());
    window.localStorage.setItem(ErrorHandlerService.errorLocation, window.location.href);

    // Must be run inside angular zone.
    this.zone.run(() => {
      // Skip location change is essential as we want to user to be able to refresh on the current page
      // in which the error has occurred;
      router.navigate(['/error'], {skipLocationChange: true});
    });
  }

  private clearErrors(): void {
    window.localStorage.removeItem(ErrorHandlerService.storage);
    window.localStorage.removeItem(ErrorHandlerService.errorLocation);
  }
}
